/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum VmsPlatform {
    All = -1,
    VirtualInfrastructure = 0,
    PublicCloud = 1,
}
